(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-at-home-gallery"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', () => {
  document.querySelectorAll('.product-slider').forEach(slider => {
    const slides = slider.querySelectorAll('.product-slide');
    const prev = slider.parentElement.querySelector('.product-slider-prev');
    const next = slider.parentElement.querySelector('.product-slider-next');

    let countDisplay = slider.parentElement.querySelector('.product-slider-count');
    if (!countDisplay) {
      countDisplay = document.createElement('span');
      countDisplay.className = 'product-slider-count';
      const heading = slider.parentElement.querySelector('h5');
      if (heading) heading.appendChild(countDisplay);
    }

    let current = 0;

    function update() {
      slides.forEach((slide, i) => {
        slide.style.display = i === current ? 'block' : 'none';
      });

      if (slides.length > 1) {
        countDisplay.innerHTML = ` <span style="color:#777;font-weight:normal;">(Item ${current + 1} of ${slides.length})</span>`;
        prev.style.display = 'inline-block';
        next.style.display = 'inline-block';
      } else {
        countDisplay.innerHTML = '';
        prev.style.display = 'none';
        next.style.display = 'none';
      }
    }

    prev.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      update();
    });

    next.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      update();
    });

    update();
  });
});
  } catch(e) { console.error(e); }
})();

})();
